import { inject, Inject, Injectable } from '@angular/core';
import { HttpMainService } from '../http-main.service';
import {
  FileUploadResponseModel,
  ListModel,
  ListRequestModel,
  MessageResponseModel,
  TicketResponseModel,
  TopicResponseModel
} from '@itb-monorepo/models';
import { Observable, of } from 'rxjs';
import { CreateTicketRequestModel } from "@itb-monorepo/models";
import { MessageRequestModel } from "@itb-monorepo/models";
import { UpdateTicketStatusRequestModel } from "@itb-monorepo/models";
import { HttpEvent } from '@angular/common/http';
import { APP_TOKEN, AppsEnum } from '@itb-monorepo/enums';
import { removeEmptyFields } from '@itb-monorepo/helper';
import { AuthService } from '../utility-services/auth.service';

@Injectable()
export class TicketsService {
  baseUrl = '/support/';
  appsEnum = AppsEnum;
  public app = inject(APP_TOKEN);
  private _HttpMainService = inject(HttpMainService);
  private authService = inject(AuthService);

  getTicketsList(params: ListRequestModel): Observable<ListModel<TicketResponseModel>> {
    if (this.app == AppsEnum.SUPPORTER)
      if (!this.authService.hasAccess('tickets:L'))
        return of();

    const url = `${this.baseUrl}v1/tickets`;
    params.include = ['topic'];
    return this._HttpMainService.get(url, removeEmptyFields(params))
  }
  getTicketListExcel(params: any): Observable<any> {
    if (this.app == AppsEnum.SUPPORTER)
      if (!this.authService.hasAccess('tickets:L'))
        return of();

    const url = `${this.baseUrl}v1/tickets`;
    return this._HttpMainService.getFile(url, 'application/csv', removeEmptyFields(params));
  }

  createTicket(model: CreateTicketRequestModel): Observable<TicketResponseModel> {
    if (this.app == AppsEnum.SUPPORTER)
      if (!this.authService.hasAccess('tickets:C'))
        return of();
    return this._HttpMainService.post(this.baseUrl + "v1/tickets", model);
  }
  getTicketDetails(ticket_id: number): Observable<TicketResponseModel> {
    if (this.app == AppsEnum.SUPPORTER)
      if (!this.authService.hasAccess('tickets:R'))
        return of();
    return this._HttpMainService.get(`${this.baseUrl}v1/tickets/${ticket_id}`);
  }

  updateTicketStatus(model: UpdateTicketStatusRequestModel, ticket_id: number): Observable<TicketResponseModel> {
    if (this.app == AppsEnum.SUPPORTER)
      if (!this.authService.hasAccess('tickets:U'))
        return of();
    return this._HttpMainService.patch(`${this.baseUrl}v1/tickets/${ticket_id}`, model);
  }
  sendMessageTicket(model: MessageRequestModel, ticket_id: number): Observable<MessageResponseModel> {
    return this._HttpMainService.post(`${this.baseUrl}v1/tickets/${ticket_id}/messages`, model);
  }
  getTopicList(): Observable<ListModel<TopicResponseModel>> {
    return this._HttpMainService.get(this.baseUrl + "v1/topics");
  }
  uploadAttachment(file: File): Observable<HttpEvent<FileUploadResponseModel>> {
    const formData = new FormData();
    formData.append('file', file);
    return this._HttpMainService.postFormData(this.baseUrl + "v1/attachments", formData);
  }
  getFile(ticketId: number, fileName: string): Observable<Blob> {
    return this._HttpMainService.getFile(`${this.baseUrl}v1/tickets/${ticketId}/attachments/${encodeURIComponent(fileName)}`);
  }

}
